<template lang="pug">
  #app.page
    Burger
    CartWidget
    //Notification
    GiftWidget

    menu-left(:data="menuLeft")

    router-view

    .page__preloader
      Preloader
</template>

<script>
import MenuLeft from './components/common/menuLeft/menuLeft';
import EventBus from './eventBus';
import Preloader from '@/components/common/preloader/Preloader.vue';
import CartWidget from '@/components/common/cartWidget/CartWidget.vue';
import Burger from '@/components/common/burger/burger.vue';
import Notification from '@/components/common/notification/notification.vue';
import GiftWidget from '@/components/common/giftWidget/giftWidget.vue';

export default {
  components: {
    Notification,
    MenuLeft,
    Preloader,
    CartWidget,
    Burger,
    GiftWidget
  },

  data() {
    return {
      menuLeft: {}
    }
  },

  created() {
    EventBus.$on('pageLoaded', res => {
      this.menuLeft = res.menuLeft;
    });
  }
}
</script>
